import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage, defineMessages, injectIntl, intlShape} from 'react-intl';

import Modal from '../../containers/modal.jsx';
import PreviewCard from './preview-card.jsx';

import styles from './theme-manager-modal.css';

const messages = defineMessages({
    modalTitle: {
        defaultMessage: 'Quản lý màu sắc phông nền IDE',
        description: 'Title of the theme manager modal',
        id: 'gen.theme.modal.title'
    },
    themeLight: {
        defaultMessage: 'Sáng',
        description: 'Light theme name',
        id: 'gen.theme.option.light'
    },
    themeDark: {
        defaultMessage: 'Tối',
        description: 'Dark theme name',
        id: 'gen.theme.option.dark'
    },
    themeCyan: {
        defaultMessage: 'Xanh',
        description: 'Cyan theme name',
        id: 'gen.theme.option.cyan'
    }
});

const ThemeManagerModalComponent = ({currentTheme, intl, onRequestClose, onSelectTheme}) => (
    <Modal
        className={styles.modalContent}
        contentLabel={intl.formatMessage(messages.modalTitle)}
        onRequestClose={onRequestClose}
    >
        <div className={styles.body}>
            <p className={styles.hint}>
                <FormattedMessage
                    defaultMessage="Chọn giao diện phù hợp với bạn. Thay đổi áp dụng ngay lập tức."
                    description="Hint text below theme manager modal title"
                    id="gen.theme.modal.hint"
                />
            </p>
            <div className={styles.cardsRow}>
                <PreviewCard
                    isActive={currentTheme === 'light'}
                    label={intl.formatMessage(messages.themeLight)}
                    themeId="light"
                    onSelect={onSelectTheme}
                />
                <PreviewCard
                    isActive={currentTheme === 'dark'}
                    label={intl.formatMessage(messages.themeDark)}
                    themeId="dark"
                    onSelect={onSelectTheme}
                />
                <PreviewCard
                    isActive={currentTheme === 'cyan'}
                    label={intl.formatMessage(messages.themeCyan)}
                    themeId="cyan"
                    onSelect={onSelectTheme}
                />
            </div>
        </div>
    </Modal>
);

ThemeManagerModalComponent.propTypes = {
    currentTheme: PropTypes.oneOf(['light', 'dark', 'cyan']).isRequired,
    intl: intlShape.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    onSelectTheme: PropTypes.func.isRequired
};

export default injectIntl(ThemeManagerModalComponent);
